import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "subtitle-2" }
const _hoisted_2 = { class: "sticky-selection-header" }
const _hoisted_3 = { class: "sticky-selection-header" }
const _hoisted_4 = { class: "sticky-selection-header" }
const _hoisted_5 = { class: "sticky-selection-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_autocomplete_filled = _resolveComponent("v-autocomplete-filled")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ProfileEdition = _resolveComponent("ProfileEdition")!
  const _component_AssociateEdition = _resolveComponent("AssociateEdition")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_OssCountrySelector = _resolveComponent("OssCountrySelector")!
  const _component_v_btn_add = _resolveComponent("v-btn-add")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "default_card_wm ma-4",
    style: {"min-width":"98%"},
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "ma-5 fill-height"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        "data-cy": "UserEdition-back",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", null, _toDisplayString(_ctx.getUserDisplayName(_ctx.user)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "d-flex justify-end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.user.type,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.type) = $event)),
                          _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeType()))
                        ],
                        items: _ctx.typesList,
                        "item-value": "value",
                        "item-title": (item) => item.text,
                        outlined: "",
                        "hide-details": "",
                        class: "mx-1",
                        disabled: _ctx.userIsSubUser,
                        density: "compact"
                      }, null, 8, ["modelValue", "items", "item-title", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "d-flex justify-end"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.user.type === 'NATURAL_PERSON')
                        ? (_openBlock(), _createBlock(_component_v_switch, {
                            key: 0,
                            modelValue: _ctx.isUserWithAccount,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isUserWithAccount) = $event)),
                            label: "Activer le compte",
                            "data-cy": "UserEdition-isUserWithAccount-switch",
                            class: "pa-0",
                            density: "compact",
                            disabled: _ctx.userIsSubUser
                          }, null, 8, ["modelValue", "disabled"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: _ctx.isDeletableUser ? 2 : 3,
                    class: "d-flex justify-end align-center"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isAccountingCurrentUser && !_ctx.isLegalPerson && !_ctx.user.email)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "elevation-0 mx-1",
                            rounded: "xl",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.forcedWithAccountUser = true)),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[97] || (_cache[97] = [
                              _createTextVNode(" Créer un compte ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        class: "elevation-0 mx-1",
                        rounded: "xl",
                        disabled: !_ctx.isValid,
                        loading: _ctx.upsertLoading,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.upsert())),
                        "data-cy": "UserEdition-update",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.user.id ? "Mettre à jour" : "Créer"), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]),
                    _: 1
                  }, 8, ["cols"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "3",
                    style: {"border-right":"1px #eaeaea solid"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, {
                        dense: "",
                        nav: "",
                        modelValue: _ctx.selectedMenu,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedMenu) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            link: "",
                            value: "information",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setSelectedMenu('information'))),
                            id: "Information"
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                icon: "$person"
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { "data-cy": "UserEdition-informations" }, {
                                default: _withCtx(() => _cache[98] || (_cache[98] = [
                                  _createElementVNode("span", { class: "subtitle-2" }, "Informations", -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            link: "",
                            value: "personnal-information",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setSelectedMenu('personnal-information'))),
                            id: "Complementaires"
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                icon: "$person"
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { "data-cy": "UserEdition-furtherInformation" }, {
                                default: _withCtx(() => _cache[99] || (_cache[99] = [
                                  _createElementVNode("span", { class: "subtitle-2" }, "Informations complémentaires", -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_ctx.showIban)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                link: "",
                                value: "bankAccount-information",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setSelectedMenu('bankAccount-information'))),
                                id: "BankAccount"
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    icon: "$fa-university"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { "data-cy": "UserEdition-BankAccount" }, {
                                    default: _withCtx(() => _cache[100] || (_cache[100] = [
                                      _createElementVNode("span", { class: "subtitle-2" }, "Informations bancaires", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.user.type === 'NATURAL_PERSON')
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                link: "",
                                value: "profil",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setSelectedMenu('profil'))),
                                id: "Profil"
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    icon: "$person"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { "data-cy": "UserEdition-roleSociety" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.isFromUsersMenu
                                            ? "Rôle dans la société"
                                            : "Rôle dans le dossier"), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (
                                    _ctx.isAccountingCurrentUser && _ctx.isAccountingUser && _ctx.isUserWithAccount
                                )
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 2,
                                link: "",
                                value: "available-accounting-firms",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setSelectedMenu('available-accounting-firms')))
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    icon: "$fa-building"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[101] || (_cache[101] = [
                                      _createElementVNode("span", { class: "subtitle-2" }, "Cabinets affectés", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (
                                    _ctx.isAccountingCurrentUser && _ctx.isAccountingUser && _ctx.enableWorkspace
                                )
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 3,
                                link: "",
                                value: "available-accounting-workspaces",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setSelectedMenu('available-accounting-workspaces')))
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    icon: "$fa-building"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { "data-cy": "UserEdition-dossierGroup" }, {
                                    default: _withCtx(() => _cache[102] || (_cache[102] = [
                                      _createElementVNode("span", { class: "subtitle-2" }, "Groupe de dossiers affectés", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.isAccountingCurrentUser)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 4,
                                link: "",
                                value: "other-companies",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setSelectedMenu('other-companies'))),
                                id: "Other companies"
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    icon: "$fa-building"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { "data-cy": "UserEdition-other-companies" }, {
                                    default: _withCtx(() => _cache[103] || (_cache[103] = [
                                      _createElementVNode("span", { class: "subtitle-2" }, "Autre(s) sociétés", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (
                                    _ctx.isAccountingCurrentUser &&
                                    (_ctx.isUserWithAccount || _ctx.user.type === 'API_USER')
                                )
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 5,
                                link: "",
                                value: "available-companies",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setSelectedMenu('available-companies'))),
                                id: "Societe"
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    icon: "$fa-building"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { "data-cy": "UserEdition-companiesAffected" }, {
                                    default: _withCtx(() => _cache[104] || (_cache[104] = [
                                      _createElementVNode("span", { class: "subtitle-2" }, "Dossiers affectés", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (!!_ctx.user.id)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 6,
                                link: "",
                                value: "investment",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setSelectedMenu('investment'))),
                                id: "Investment"
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    icon: "$person"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { "data-cy": "UserEdition-associateParameters" }, {
                                    default: _withCtx(() => _cache[105] || (_cache[105] = [
                                      _createElementVNode("span", { class: "subtitle-2" }, "Associé", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "9",
                    class: "pl-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window, {
                        modelValue: _ctx.selectedMenu,
                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.selectedMenu) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_window_item, { value: "information" }, {
                            default: _withCtx(() => [
                              (!_ctx.isLegalPerson)
                                ? (_openBlock(), _createBlock(_component_v_form, {
                                    key: 0,
                                    modelValue: _ctx.formIsValid,
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formIsValid) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "pt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.isUserWithAccount || _ctx.user.type === 'API_USER')
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 0,
                                                cols: "4"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.availableProfiles && _ctx.availableProfiles.length)
                                                    ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                        key: 0,
                                                        modelValue: _ctx.profileId,
                                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.profileId) = $event)),
                                                        items: _ctx.availableProfiles,
                                                        "item-title": _ctx.getProfileName,
                                                        "item-value": "id",
                                                        label: "Profil utilisateur",
                                                        outlined: "",
                                                        "hide-details": "auto",
                                                        rules: [
                                                    (p) =>
                                                        (!!p && !!p.length) ||
                                                        'Sélectionnez un profil',
                                                ],
                                                        density: "compact",
                                                        "data-cy": "UserEdition-selectProfile"
                                                      }, null, 8, ["modelValue", "items", "item-title", "rules"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_v_col, {
                                                key: 1,
                                                cols: "4",
                                                class: "pr-2"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    outlined: "",
                                                    readonly: "",
                                                    "hide-details": "",
                                                    type: "text",
                                                    disabled: _ctx.userIsSubUser,
                                                    label: _ctx.isFromUsersMenu ? 'Société' : 'Dossier',
                                                    modelValue: _ctx.user.company.name,
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.user.company.name) = $event)),
                                                    "data-cy": "UserEdition-companyName",
                                                    density: "compact"
                                                  }, null, 8, ["disabled", "label", "modelValue"])
                                                ]),
                                                _: 1
                                              }))
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "pt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "4",
                                            class: "pr-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field_filled, {
                                                modelValue: _ctx.user.firstname,
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.user.firstname) = $event)),
                                                type: "text",
                                                label: "Prénom",
                                                outlined: "",
                                                "hide-details": "auto",
                                                disabled: _ctx.userIsSubUser,
                                                "data-cy": "UserEdition-userFirstname",
                                                density: "compact"
                                              }, null, 8, ["modelValue", "disabled"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "4",
                                            class: "pr-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field_filled, {
                                                modelValue: _ctx.user.lastname,
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.user.lastname) = $event)),
                                                type: "text",
                                                label: "Nom",
                                                outlined: "",
                                                disabled: _ctx.userIsSubUser,
                                                "hide-details": "auto",
                                                rules: [(v) => !!v || 'Un nom est requis'],
                                                "data-cy": "UserEdition-userLastname",
                                                density: "compact"
                                              }, null, 8, ["modelValue", "disabled", "rules"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { cols: "4" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field_filled, {
                                                modelValue: _ctx.user.marriedName,
                                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.user.marriedName) = $event)),
                                                type: "text",
                                                label: "Nom marital",
                                                outlined: "",
                                                disabled: _ctx.userIsSubUser,
                                                "hide-details": "auto",
                                                "data-cy": "UserEdition-userMarriedName",
                                                density: "compact"
                                              }, null, 8, ["modelValue", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.isUserWithAccount)
                                        ? (_openBlock(), _createBlock(_component_v_row, {
                                            key: 0,
                                            "no-gutters": "",
                                            class: "pt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "4",
                                                class: "pr-2"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.userIsSubUser)
                                                    ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                        key: 0,
                                                        type: "text",
                                                        outlined: "",
                                                        "hide-details": "auto",
                                                        label: "Email",
                                                        disabled: "",
                                                        "model-value": _ctx.getDisplayEmail(_ctx.user.email),
                                                        density: "compact",
                                                        "data-cy": "UserEdition-accountEmail"
                                                      }, null, 8, ["model-value"]))
                                                    : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                        key: 1,
                                                        "data-cy": "UserEdition-email",
                                                        modelValue: _ctx.user.email,
                                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.user.email) = $event)),
                                                        type: "text",
                                                        outlined: "",
                                                        "hide-details": "auto",
                                                        label: "Email",
                                                        rules: [
                                                    (email) =>
                                                        _ctx.emailPattern.test(email) ||
                                                        'Un email est requis',
                                                    (email) =>
                                                        !_ctx.alreadyExistEmails[email] ||
                                                        'L\'email existe déjà',
                                                ]
                                                      }, null, 8, ["modelValue", "rules"]))
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "4",
                                                class: "pr-2"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    outlined: "",
                                                    readonly: "",
                                                    "hide-details": "",
                                                    type: "text",
                                                    label: _ctx.isFromUsersMenu ? 'Société' : 'Dossier',
                                                    disabled: _ctx.userIsSubUser,
                                                    modelValue: _ctx.user.company.name,
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.user.company.name) = $event)),
                                                    density: "compact"
                                                  }, null, 8, ["label", "disabled", "modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              (_ctx.displayPasswordInput)
                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                    key: 0,
                                                    cols: "4"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.isPasswordRequired)
                                                        ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                            key: 0,
                                                            outlined: "",
                                                            required: !_ctx.user.id,
                                                            label: "Mot de passe",
                                                            type: _ctx.displayPassword ? 'text' : 'password',
                                                            "append-inner-icon": 
                                                    _ctx.displayPassword ? '$oss-eye' : '$oss-eye-slash'
                                                ,
                                                            modelValue: _ctx.password,
                                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.password) = $event)),
                                                            rules: [
                                                    (p) =>
                                                        !p ||
                                                        !p.length ||
                                                        p.length >= 4 ||
                                                        'Mot de passe requis (4 caractères minimum)',
                                                ],
                                                            disabled: _ctx.userIsSubUser,
                                                            "hide-details": "auto",
                                                            density: "compact",
                                                            "onClick:appendInner": _cache[24] || (_cache[24] = ($event: any) => (
                                                    _ctx.displayPassword = !_ctx.displayPassword
                                                ))
                                                          }, null, 8, ["required", "type", "append-inner-icon", "modelValue", "rules", "disabled"]))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.isUserWithAccount && _ctx.user.externalId)
                                        ? (_openBlock(), _createBlock(_component_v_row, {
                                            key: 1,
                                            "no-gutters": "",
                                            class: "pt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "4",
                                                class: "pr-2"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": "",
                                                    readonly: "",
                                                    type: "text",
                                                    label: "Identifiant externe",
                                                    modelValue: _ctx.user.externalId,
                                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.user.externalId) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.isPasswordRequired && _ctx.displayPasswordInput)
                                        ? (_openBlock(), _createBlock(_component_v_row, {
                                            key: 2,
                                            "no-gutters": "",
                                            class: "d-flex justify-end pt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "4" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    outlined: "",
                                                    required: !_ctx.user.id,
                                                    "hide-details": "auto",
                                                    label: "Confirmer le mot de passe",
                                                    type: _ctx.displayPassword ? 'text' : 'password',
                                                    "append-inner-icon": 
                                                    _ctx.displayPassword ? '$oss-eye' : '$oss-eye-slash'
                                                ,
                                                    disabled: _ctx.userIsSubUser,
                                                    modelValue: _ctx.confirmPassword,
                                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                                                    rules: [
                                                    (p) =>
                                                        p === _ctx.password ||
                                                        'Le mot de passe de correspond pas',
                                                ],
                                                    density: "compact",
                                                    "onClick:appendInner": _cache[27] || (_cache[27] = ($event: any) => (
                                                    _ctx.displayPassword = !_ctx.displayPassword
                                                ))
                                                  }, null, 8, ["required", "type", "append-inner-icon", "disabled", "modelValue", "rules"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : (_openBlock(), _createBlock(_component_v_form, {
                                    key: 1,
                                    modelValue: _ctx.formIsValid,
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formIsValid) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "pt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "8",
                                            class: "pr-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field_filled, {
                                                modelValue: _ctx.user.lastname,
                                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.user.lastname) = $event)),
                                                type: "text",
                                                label: "Nom de la société",
                                                outlined: "",
                                                "hide-details": "",
                                                disabled: _ctx.userIsSubUser,
                                                rules: [
                                                    (v) =>
                                                        !!v || 'Le nom de l\'entreprise est requis',
                                                ],
                                                density: "compact"
                                              }, null, 8, ["modelValue", "disabled", "rules"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "4",
                                            class: "pr-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field_filled, {
                                                outlined: "",
                                                "hide-details": "",
                                                type: "text",
                                                label: _ctx.isFromUsersMenu ? 'Société' : 'Dossier',
                                                disabled: "",
                                                modelValue: _ctx.user.company.name,
                                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.user.company.name) = $event)),
                                                density: "compact"
                                              }, null, 8, ["label", "modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "pt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "5",
                                            class: "pr-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_autocomplete_filled, {
                                                modelValue: _ctx.user.legalForm,
                                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.user.legalForm) = $event)),
                                                items: _ctx.legalForms,
                                                "item-title": _ctx.formatItemTitle,
                                                "item-value": "id",
                                                disabled: _ctx.userIsSubUser,
                                                label: "Forme juridique"
                                              }, null, 8, ["modelValue", "items", "item-title", "disabled"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "3",
                                            class: "pr-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field_filled, {
                                                modelValue: _ctx.user.siret,
                                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.user.siret) = $event)),
                                                type: "text",
                                                label: "SIRET",
                                                rules: _ctx.rulesSiret,
                                                onInput: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onInputSetTruncatedSiret())),
                                                outlined: "",
                                                "hide-details": "",
                                                disabled: _ctx.userIsSubUser,
                                                density: "compact"
                                              }, null, 8, ["modelValue", "rules", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: "profil" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ProfileEdition, {
                                ref: "profileEdition",
                                company: _ctx.user.company,
                                user: _ctx.user,
                                isAccountActivated: _ctx.isUserWithAccount
                              }, null, 8, ["company", "user", "isAccountActivated"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, {
                            value: "investment",
                            style: {"min-width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_AssociateEdition, {
                                modelValue: _ctx.user,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.user) = $event)),
                                ref: "investmentEdition",
                                company: _ctx.user.company,
                                legalForm: _ctx.legalForm
                              }, null, 8, ["modelValue", "company", "legalForm"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: "bankAccount-information" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => _cache[106] || (_cache[106] = [
                                      _createElementVNode("span", { class: "title ml-2" }, "Informations bancaires pour le paiement", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.selectedBankAccount.name,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.selectedBankAccount.name) = $event)),
                                        label: "Nom de la banque",
                                        outlined: "",
                                        "hide-details": "",
                                        rules: [_ctx.rules.notEmpty],
                                        disabled: _ctx.userIsSubUser,
                                        "data-cy": "UserEdition-bankName",
                                        density: "compact"
                                      }, null, 8, ["modelValue", "rules", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.selectedBankAccount.iban,
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.selectedBankAccount.iban) = $event)),
                                        label: "IBAN",
                                        outlined: "",
                                        "hide-details": "",
                                        rules: [
                                                _ctx.rules.checkIBAN,
                                                (v) =>
                                                    v.length <= 34 ||
                                                    'IBAN must be 34 characters or less',
                                            ],
                                        onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onIbanChanged(_ctx.selectedBankAccount))),
                                        onInput: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onInputSetTruncatedIban())),
                                        maxlength: "34",
                                        density: "compact",
                                        "data-cy": "UserEdition-IBAN"
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.selectedBankAccount.bic,
                                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.selectedBankAccount.bic) = $event)),
                                        label: "BIC",
                                        outlined: "",
                                        "hide-details": "",
                                        rules: [_ctx.rules.notEmpty, _ctx.rules.checkBIC],
                                        disabled: _ctx.userIsSubUser,
                                        density: "compact",
                                        "data-cy": "UserEdition-BIC"
                                      }, null, 8, ["modelValue", "rules", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: "personnal-information" }, {
                            default: _withCtx(() => [
                              (!_ctx.isLegalPerson)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "py-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: "d-flex align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_radio_group, {
                                              modelValue: _ctx.user.civility,
                                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.user.civility) = $event)),
                                              inline: "",
                                              density: "compact",
                                              "hide-details": "",
                                              class: "mt-0",
                                              disabled: _ctx.userIsSubUser,
                                              color: "primary"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_radio, {
                                                  ripple: false,
                                                  label: "M",
                                                  value: "MR",
                                                  "data-cy": "UserEdition-M"
                                                }),
                                                _createVNode(_component_v_radio, {
                                                  ripple: false,
                                                  label: "Mme",
                                                  value: "MS",
                                                  "data-cy": "UserEdition-Mme"
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "pl-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field_filled, {
                                              modelValue: _ctx.user.phoneNumber,
                                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.user.phoneNumber) = $event)),
                                              label: "Numéro de téléphone",
                                              required: "",
                                              outlined: "",
                                              "hide-details": "",
                                              disabled: _ctx.userIsSubUser,
                                              "data-cy": "UserEdition-tel",
                                              density: "compact"
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "pl-2"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.userIsSubUser)
                                              ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                  key: 0,
                                                  type: "text",
                                                  outlined: "",
                                                  "hide-details": "auto",
                                                  label: "Email",
                                                  disabled: "",
                                                  "model-value": 
                                                    _ctx.getDisplayEmail(_ctx.user.emailSubscription)
                                                ,
                                                  "data-cy": "UserEdition-contactEmail",
                                                  density: "compact"
                                                }, null, 8, ["model-value"]))
                                              : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                  key: 1,
                                                  modelValue: _ctx.user.emailSubscription,
                                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.user.emailSubscription) = $event)),
                                                  type: "text",
                                                  outlined: "",
                                                  "hide-details": "auto",
                                                  label: "Email de contact",
                                                  "data-cy": "UserEdition-contactEmail"
                                                }, null, 8, ["modelValue"]))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-2" }, {
                                          default: _withCtx(() => _cache[107] || (_cache[107] = [
                                            _createTextVNode(" Naissance ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_divider)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "py-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "2" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_oss_date_picker_filled, {
                                              modelValue: _ctx.user.birthDate,
                                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.user.birthDate) = $event)),
                                              "hide-details": true,
                                              label: "Date",
                                              "text-field-read-only": false,
                                              disabled: _ctx.userIsSubUser,
                                              "data-cy": "UserEdition-birthday"
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "pl-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field_filled, {
                                              modelValue: _ctx.user.birthDepartment,
                                              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.user.birthDepartment) = $event)),
                                              label: "Département",
                                              required: "",
                                              outlined: "",
                                              "hide-details": "",
                                              disabled: _ctx.userIsSubUser,
                                              "data-cy": "UserEdition-birthDepartment",
                                              density: "compact"
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "pl-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field_filled, {
                                              modelValue: _ctx.user.birthPlace,
                                              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.user.birthPlace) = $event)),
                                              label: "Commune",
                                              required: "",
                                              outlined: "",
                                              "hide-details": "",
                                              disabled: _ctx.userIsSubUser,
                                              "data-cy": "UserEdition-birthPlace",
                                              density: "compact"
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "pl-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_OssCountrySelector, {
                                              modelValue: _ctx.user.birthCountry,
                                              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.user.birthCountry) = $event)),
                                              required: "",
                                              disabled: _ctx.userIsSubUser,
                                              "data-cy": "UserEdition-birthCountry"
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : (_openBlock(), _createBlock(_component_v_row, {
                                    key: 1,
                                    "no-gutters": "",
                                    class: "py-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field_filled, {
                                            modelValue: _ctx.user.phoneNumber,
                                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.user.phoneNumber) = $event)),
                                            label: "Numéro de téléphone",
                                            required: "",
                                            outlined: "",
                                            "hide-details": "",
                                            disabled: _ctx.userIsSubUser,
                                            density: "compact"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-2" }, {
                                    default: _withCtx(() => _cache[108] || (_cache[108] = [
                                      _createTextVNode(" Adresse ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "pt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "5",
                                    class: "d-flex pr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.user.address,
                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.user.address) = $event)),
                                        label: _ctx.$t('settings.address'),
                                        rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                        required: "",
                                        outlined: "",
                                        "hide-details": "",
                                        disabled: _ctx.userIsSubUser,
                                        "data-cy": "UserEdition-address",
                                        density: "compact"
                                      }, null, 8, ["modelValue", "label", "rules", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "3",
                                    class: "d-flex pr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.user.addressComplement,
                                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.user.addressComplement) = $event)),
                                        label: _ctx.$t('settings.addressComplement'),
                                        outlined: "",
                                        "hide-details": "",
                                        disabled: _ctx.userIsSubUser,
                                        "data-cy": "UserEdition-addressComplement",
                                        density: "compact"
                                      }, null, 8, ["modelValue", "label", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "d-flex pr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.user.postalCode,
                                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.user.postalCode) = $event)),
                                        label: _ctx.$t('settings.postalCode'),
                                        rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                        required: "",
                                        outlined: "",
                                        "hide-details": "",
                                        disabled: _ctx.userIsSubUser,
                                        "data-cy": "UserEdition-codePostal",
                                        density: "compact"
                                      }, null, 8, ["modelValue", "label", "rules", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "3",
                                    class: "d-flex pr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.user.city,
                                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.user.city) = $event)),
                                        label: _ctx.$t('settings.city'),
                                        rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                        required: "",
                                        outlined: "",
                                        "hide-details": "",
                                        disabled: _ctx.userIsSubUser,
                                        "data-cy": "UserEdition-city",
                                        density: "compact"
                                      }, null, 8, ["modelValue", "label", "rules", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "3",
                                    class: "d-flex pr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_OssCountrySelector, {
                                        modelValue: _ctx.user.country,
                                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.user.country) = $event)),
                                        required: "",
                                        disabled: _ctx.userIsSubUser,
                                        "data-cy": "UserEdition-country"
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_ctx.gainOrLossReadRight)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createVNode(_component_v_divider),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "py-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "4",
                                          class: "pr-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field_filled, {
                                              modelValue: _ctx.user.hourlyCost,
                                              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.user.hourlyCost) = $event)),
                                              modelModifiers: { number: true },
                                              outlined: "",
                                              label: "Coût horaire",
                                              disabled: _ctx.userIsSubUser || !_ctx.gainOrLossWriteRight,
                                              density: "compact"
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: "available-companies" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "pt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "8",
                                    class: "pr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.searchCompany,
                                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.searchCompany) = $event)),
                                        label: "Rechercher",
                                        outlined: "",
                                        "hide-details": "",
                                        disabled: _ctx.userIsSubUser,
                                        density: "compact",
                                        "append-inner-icon": "$search",
                                        clearable: "",
                                        "onClick:clear": _cache[56] || (_cache[56] = ($event: any) => (_ctx.searchCompany = ''))
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_add, {
                                        size: "small",
                                        class: "ml-2 text-center",
                                        onClick: _ctx.openClientCompaniesDialog
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "pt-2"
                              }, {
                                default: _withCtx(() => [
                                  (!_ctx.mySelectedCompanies.length)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" Aucun dossier trouvé ")
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mySelectedCompanies, (comp) => {
                                    return (_openBlock(), _createBlock(_component_v_col, {
                                      cols: "6",
                                      key: comp.id,
                                      class: "pr-2 pb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, {
                                          class: "oss-list-item",
                                          onClick: ($event: any) => (_ctx.onCompanySelectFromMainList(comp))
                                        }, {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              color: 
                                                        _ctx.hasRight(comp)
                                                            ? _ctx.isAvailableCompanies(comp.id)
                                                                ? 'primary'
                                                                : 'secondary'
                                                            : 'grey'
                                                    ,
                                              disabled: _ctx.currentUserIsSubUser,
                                              location: "start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.isAvailableCompanies(comp.id)
                                                            ? "$check_box"
                                                            : "$check_box_outline_blank"), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["color", "disabled"])
                                          ]),
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: "$fa-user-cog",
                                              color: _ctx.hasRight(comp) ? 'primary' : 'grey',
                                              onClick: _withModifiers(($event: any) => (_ctx.setCompanySettings(comp)), ["stop"])
                                            }, null, 8, ["color", "onClick"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(comp.name), 1),
                                                (_ctx.isOwner(_ctx.user, comp))
                                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                                      key: 0,
                                                      label: "",
                                                      color: "primary",
                                                      class: "ml-2",
                                                      size: "small",
                                                      variant: "outlined"
                                                    }, {
                                                      default: _withCtx(() => _cache[109] || (_cache[109] = [
                                                        _createTextVNode("Propriétaire")
                                                      ])),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_list_item_subtitle, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.getSiretValue(comp.siret)), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: "other-companies" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "pt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "8",
                                    class: "pr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.searchCompany,
                                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.searchCompany) = $event)),
                                        label: "Rechercher",
                                        outlined: "",
                                        "hide-details": "",
                                        disabled: _ctx.userIsSubUser,
                                        density: "compact",
                                        "append-inner-icon": "$search",
                                        clearable: "",
                                        "onClick:clear": _cache[58] || (_cache[58] = ($event: any) => (_ctx.searchCompany = ''))
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_add, {
                                        size: "small",
                                        class: "ml-2 text-center",
                                        onClick: _ctx.openOtherClientCompaniesDialog
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "pt-2"
                              }, {
                                default: _withCtx(() => [
                                  (!_ctx.myOtherCompanies.length)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" Aucune société trouvée ")
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myOtherCompanies, (userCompany) => {
                                    return (_openBlock(), _createBlock(_component_v_col, {
                                      cols: "6",
                                      key: userCompany.id,
                                      class: "pr-2 pb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, {
                                          class: "oss-list-item",
                                          onClick: ($event: any) => (_ctx.onOtherCompanyClicked(userCompany))
                                        }, {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              color: 'primary',
                                              location: "start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(userCompany.partOfCompany
                                                            ? "$check_box"
                                                            : "$check_box_outline_blank"), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: "$fa-user-cog",
                                              onClick: _withModifiers(($event: any) => (
                                                        _ctx.setCompanySettings(userCompany.company)
                                                    ), ["stop"])
                                            }, null, 8, ["onClick"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(userCompany.company.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_list_item_subtitle, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.getSiretValue(userCompany.company.siret)), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: "available-accounting-firms" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "pt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "8",
                                    class: "pr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.searchAccountingFirm,
                                        "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.searchAccountingFirm) = $event)),
                                        label: "Rechercher",
                                        outlined: "",
                                        "hide-details": "",
                                        density: "compact",
                                        "append-inner-icon": "$search",
                                        clearable: "",
                                        "onClick:clear": _cache[60] || (_cache[60] = ($event: any) => (_ctx.searchAccountingFirm = ''))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_add, {
                                        size: "small",
                                        class: "ml-2 text-center",
                                        onClick: _ctx.openAccountingFirmsDialog
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "pt-2"
                              }, {
                                default: _withCtx(() => [
                                  (!_ctx.mySelectedAccountingFirms.length)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" Aucun cabinet trouvé ")
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "mb-2"
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mySelectedAccountingFirms, (comp) => {
                                    return (_openBlock(), _createBlock(_component_v_col, {
                                      cols: "6",
                                      key: comp.id,
                                      class: "pr-2 pb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, {
                                          ripple: "",
                                          class: "oss-list-item",
                                          disabled: _ctx.userIsSubUser
                                        }, {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: _ctx.userAccountingFirmIds,
                                              "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.userAccountingFirmIds) = $event)),
                                              value: comp.id,
                                              disabled: 
                                                        _ctx.userIsSubUser ||
                                                        _ctx.isParentAccountingFirm(comp.id)
                                                    ,
                                              onClick: ($event: any) => (
                                                        _ctx.onAccountingFirmSelectFromMainList(comp.id)
                                                    )
                                            }, null, 8, ["modelValue", "value", "disabled", "onClick"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(comp.name +
                                                    (_ctx.isParentAccountingFirm(comp.id)
                                                        ? " (Cabinet principale)"
                                                        : "")), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            (comp.siret)
                                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.getSiretValue(comp.siret)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: "available-accounting-workspaces" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "pt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "8",
                                    class: "pr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.searchAccountingWorkspace,
                                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.searchAccountingWorkspace) = $event)),
                                        label: "Rechercher",
                                        outlined: "",
                                        "hide-details": "",
                                        density: "compact",
                                        "append-inner-icon": "$search",
                                        clearable: "",
                                        "onClick:clear": _cache[63] || (_cache[63] = ($event: any) => (_ctx.searchAccountingWorkspace = '')),
                                        "data-cy": "userEdition-searchAccountingWorkspace"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_add, {
                                        size: "small",
                                        class: "ml-2 text-center",
                                        onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.openAccWorkspacesDialog())),
                                        "data-cy": "userEdition-addAccountingWorkspace"
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "pt-2"
                              }, {
                                default: _withCtx(() => [
                                  (!_ctx.mySelectedAccWorkspaces.length)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" Aucun groupe de dossiers trouvé ")
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mySelectedAccWorkspaces, (aW) => {
                                    return (_openBlock(), _createBlock(_component_v_col, {
                                      cols: "6",
                                      key: aW.id,
                                      class: "pr-2 pb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, {
                                          ripple: "",
                                          class: "oss-list-item",
                                          disabled: _ctx.currentUserIsSubUser,
                                          "data-cy": "userEdition-addedAccountingWorkspace"
                                        }, {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: _ctx.accountingWorkspacesOfUser,
                                              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.accountingWorkspacesOfUser) = $event)),
                                              disabled: _ctx.currentUserIsSubUser,
                                              onClick: ($event: any) => (_ctx.onWorkspaceSelectFromMainList(aW.id)),
                                              value: aW.id
                                            }, null, 8, ["modelValue", "disabled", "onClick", "value"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(aW.name || "XXX"), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.companySettingDialog,
        "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.companySettingDialog) = $event)),
        title: _ctx.titleCompanySetting,
        actions: _ctx.profileEditionActions,
        width: "60vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs, {
            modelValue: _ctx.profileEditionTab,
            "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.profileEditionTab) = $event)),
            "fixed-tabs": "",
            style: {"background-color":"transparent !important","border-radius":"16px","overflow":"hidden"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tab, {
                value: "profileEdition",
                href: "#profileEdition"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.isFromUsersMenu ? "Rôle dans la société" : "Rôle dans le dossier"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_tab, {
                value: "associateEdition",
                href: "#associateEdition"
              }, {
                default: _withCtx(() => _cache[110] || (_cache[110] = [
                  _createElementVNode("strong", null, "Associé", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_tabs_window, {
            modelValue: _ctx.profileEditionTab,
            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.profileEditionTab) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "profileEdition" }, {
                default: _withCtx(() => [
                  (_ctx.companySettingDialog)
                    ? (_openBlock(), _createBlock(_component_ProfileEdition, {
                        key: 0,
                        user: _ctx.user,
                        company: _ctx.companySettingSelected,
                        actions: _ctx.profileEditionActions,
                        isAccountActivated: _ctx.isUserWithAccount,
                        onUpserted: _cache[68] || (_cache[68] = ($event: any) => {
                            _ctx.companySettingDialog = false;
                            _ctx.profileEditionTab = 'profileEdition';
                        })
                      }, null, 8, ["user", "company", "actions", "isAccountActivated"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "associateEdition" }, {
                default: _withCtx(() => [
                  (_ctx.companySettingDialog)
                    ? (_openBlock(), _createBlock(_component_AssociateEdition, {
                        key: 0,
                        company: _ctx.companySettingSelected,
                        modelValue: _ctx.user,
                        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.user) = $event)),
                        legalForm: _ctx.legalForm,
                        onUpserted: _cache[70] || (_cache[70] = ($event: any) => {
                            _ctx.companySettingDialog = false;
                            _ctx.profileEditionTab = 'profileEdition';
                        })
                      }, null, 8, ["company", "modelValue", "legalForm"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "actions"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.showClientCompaniesDialog,
        "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.showClientCompaniesDialog) = $event)),
        title: "Ajouter des dossiers",
        onValid: _ctx.onValidateCompaniesDialog,
        width: "80vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "pt-0 selection"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "8",
                      class: "mt-2 mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.searchCompany,
                          "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.searchCompany) = $event)),
                          label: "Rechercher",
                          outlined: "",
                          "hide-details": "",
                          disabled: _ctx.userIsSubUser,
                          density: "compact",
                          "append-inner-icon": "$search",
                          clearable: "",
                          "onClick:clear": _cache[74] || (_cache[74] = ($event: any) => (_ctx.searchCompany = ''))
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.workingFilteredClientCompanies.length)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      cols: "12",
                      class: "mb-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          elevation: "0",
                          class: "mr-2",
                          rounded: "xl",
                          onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.selectAllCompany())),
                          "data-cy": "UserEdition-allCompanies",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[111] || (_cache[111] = [
                            _createTextVNode(" Sélectionner tous les dossiers ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          elevation: "0",
                          rounded: "xl",
                          onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.diselectAllCompany())),
                          "data-cy": "UserEdition-notAllCompanies",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[112] || (_cache[112] = [
                            _createTextVNode(" Désélectionner tous les dossiers ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  (!_ctx.workingFilteredClientCompanies.length)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "12",
                        class: "text-center py-3"
                      }, {
                        default: _withCtx(() => _cache[113] || (_cache[113] = [
                          _createElementVNode("span", null, "Aucun dossier trouvé", -1)
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workingFilteredClientCompanies, (comp) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: comp.id
                    }, [
                      (!_ctx.isAvailableCompanies(comp.id))
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "6",
                            class: "pr-2 pb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                ripple: "",
                                class: "oss-list-item"
                              }, _createSlots({
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.selectedClientCompanies,
                                    "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.selectedClientCompanies) = $event)),
                                    value: comp,
                                    color: "primary",
                                    "value-comparator": (a, b) => a.id === b.id,
                                    disabled: _ctx.currentUserIsSubUser || !_ctx.hasRight(comp)
                                  }, null, 8, ["modelValue", "value", "value-comparator", "disabled"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(comp.name), 1),
                                      (_ctx.isOwner(_ctx.user, comp))
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 0,
                                            size: "small",
                                            label: "",
                                            color: "primary",
                                            class: "ml-2",
                                            variant: "outlined"
                                          }, {
                                            default: _withCtx(() => _cache[114] || (_cache[114] = [
                                              _createTextVNode("Propriétaire")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getSubTitleCompany(comp)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, [
                                (_ctx.isInInternalManagement)
                                  ? {
                                      name: "append",
                                      fn: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          variant: "tonal",
                                          size: "small",
                                          icon: "$fa-user-cog",
                                          color: _ctx.hasRight(comp) ? 'primary' : 'grey',
                                          onClick: _withModifiers(($event: any) => (_ctx.setCompanySettings(comp)), ["stop"])
                                        }, null, 8, ["color", "onClick"])
                                      ]),
                                      key: "0"
                                    }
                                  : undefined
                              ]), 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onValid"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.showOtherCompaniesDialog,
        "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.showOtherCompaniesDialog) = $event)),
        title: "Associer à d'autres sociétés",
        onValid: _ctx.onValidateOtherCompaniesDialog,
        width: "80vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "pt-0 selection"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "8",
                      class: "mt-2 mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.searchCompany,
                          "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.searchCompany) = $event)),
                          label: "Rechercher",
                          outlined: "",
                          "hide-details": "",
                          disabled: _ctx.userIsSubUser,
                          density: "compact",
                          "append-inner-icon": "$search",
                          clearable: "",
                          "onClick:clear": _cache[80] || (_cache[80] = ($event: any) => (_ctx.searchCompany = ''))
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  (!_ctx.workingFilteredClientCompanies.length)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "12",
                        class: "text-center py-3"
                      }, {
                        default: _withCtx(() => _cache[115] || (_cache[115] = [
                          _createElementVNode("span", null, "Aucun dossier trouvé", -1)
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workingFilteredClientCompanies, (comp) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: comp.id
                    }, [
                      (!_ctx.isAlreadyOtherCompany(comp.id) && _ctx.user.company.id !== comp.id)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "6",
                            class: "pr-2 pb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                ripple: "",
                                class: "oss-list-item"
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.selectedOtherCompanies,
                                    "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.selectedOtherCompanies) = $event)),
                                    value: comp,
                                    color: "primary",
                                    "value-comparator": (a, b) => a.id === b.id
                                  }, null, 8, ["modelValue", "value", "value-comparator"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(comp.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getSubTitleCompany(comp)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onValid"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.showAccWorkspacesDialog,
        "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.showAccWorkspacesDialog) = $event)),
        title: "Ajouter des groupes de dossiers",
        onValid: _cache[89] || (_cache[89] = ($event: any) => (_ctx.onValidateAccWorkspacesDialog())),
        width: "80vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            "no-gutters": "",
            class: "pt-0 selection"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "py-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "8",
                      class: "pr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.searchAccountingWorkspace,
                          "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.searchAccountingWorkspace) = $event)),
                          label: "Rechercher",
                          outlined: "",
                          "hide-details": "",
                          density: "compact",
                          "append-inner-icon": "$search",
                          clearable: "",
                          "onClick:clear": _cache[84] || (_cache[84] = ($event: any) => (_ctx.searchAccountingWorkspace = ''))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      elevation: "0",
                      class: "mr-2",
                      rounded: "xl",
                      onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.selectAllAccountingWorkspaces())),
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[116] || (_cache[116] = [
                        _createTextVNode(" Sélectionner tous les groupes ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      elevation: "0",
                      rounded: "xl",
                      onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.diselectAllAccountingWorkspaces())),
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[117] || (_cache[117] = [
                        _createTextVNode(" Désélectionner tous les groupes ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "pt-2"
              }, {
                default: _withCtx(() => [
                  (!_ctx.workingFilteredAccWorkspaces.length)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "12",
                        class: "text-center py-3"
                      }, {
                        default: _withCtx(() => _cache[118] || (_cache[118] = [
                          _createElementVNode("span", null, "Aucun groupe de dossiers trouvé", -1)
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workingFilteredAccWorkspaces, (aW, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (aW && !_ctx.accountingWorkspacesOfUser.includes(aW.id))
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            cols: "6",
                            key: index,
                            class: "pr-2 pb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                ripple: "",
                                class: "oss-list-item",
                                "data-cy": "userEdition-dossierGroup",
                                disabled: _ctx.currentUserIsSubUser
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.selectedAccWorkspaces,
                                    "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.selectedAccWorkspaces) = $event)),
                                    value: aW?.id,
                                    color: "primary",
                                    disabled: _ctx.currentUserIsSubUser
                                  }, null, 8, ["modelValue", "value", "disabled"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(aW?.name || "XXX"), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["disabled"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.showAccountingFirmsDialog,
        "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.showAccountingFirmsDialog) = $event)),
        title: "Ajouter des cabinets",
        onValid: _cache[96] || (_cache[96] = ($event: any) => (_ctx.onValidateAccountingFirmDialog())),
        width: "80vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { class: "selection pt-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "py-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "8",
                      class: "pr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.searchAccountingFirm,
                          "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.searchAccountingFirm) = $event)),
                          label: "Rechercher",
                          outlined: "",
                          "hide-details": "",
                          density: "compact",
                          "append-inner-icon": "$search",
                          clearable: "",
                          "onClick:clear": _cache[91] || (_cache[91] = ($event: any) => (_ctx.searchAccountingFirm = ''))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      elevation: "0",
                      class: "mr-2",
                      rounded: "xl",
                      onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.selectAllAccountingFirms())),
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[119] || (_cache[119] = [
                        _createTextVNode(" Sélectionner tous les cabinets ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      elevation: "0",
                      rounded: "xl",
                      onClick: _cache[93] || (_cache[93] = ($event: any) => (_ctx.diselectAllAccountingFirms())),
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[120] || (_cache[120] = [
                        _createTextVNode(" Désélectionner tous les cabinets ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "pt-2"
              }, {
                default: _withCtx(() => [
                  (!_ctx.workingFilteredAccountingFirms.length)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "12",
                        class: "text-center py-3"
                      }, {
                        default: _withCtx(() => _cache[121] || (_cache[121] = [
                          _createElementVNode("span", null, "Aucun cabinet trouvé", -1)
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workingFilteredAccountingFirms, (comp) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: comp.id
                    }, [
                      (!_ctx.userAccountingFirmIds.includes(comp.id))
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "6",
                            class: "pr-2 pb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                ripple: "",
                                class: "oss-list-item",
                                disabled: _ctx.userIsSubUser
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.selectedAccountingFirms,
                                    "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.selectedAccountingFirms) = $event)),
                                    disabled: _ctx.userIsSubUser || _ctx.isParentAccountingFirm(comp.id),
                                    value: comp.id
                                  }, null, 8, ["modelValue", "disabled", "value"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(comp.name +
                                        (_ctx.isParentAccountingFirm(comp.id)
                                            ? " (Cabinet principale)"
                                            : "")), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getSiretValue(comp.siret)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["disabled"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}